import { Table } from 'antd';
import Column from 'antd/es/table/Column';
import { useHistory } from 'react-router-dom';

import { ActionCellMenu } from 'app/components/lists/ActionCellMenu';
import { dateTimeCell } from 'app/components/lists/cells';
import { useGiftCardBookings } from 'app/hooks/data/core/admin/giftcards/giftcardBookings';
import type { GiftCardBooking } from 'app/typings/core/admin/giftcards/giftcardBookings';
import { sortDate } from 'app/utils/sort';
import { formatCurrency } from 'app/utils/strings';

const sortBookingsByDateField = (
  valueA: GiftCardBooking,
  valueB: GiftCardBooking
) => sortDate(valueA.checkIn, valueB.checkIn, 'ascend');

const sortBookingsByAmountField = (
  valueA: GiftCardBooking,
  valueB: GiftCardBooking
) => valueA.giftCardAmount - valueB.giftCardAmount;

type BookingsLinkedProps = {
  code: string;
  currency: string;
};

export const BookingsLinked: React.FC<BookingsLinkedProps> = ({
  currency,
  code,
}: BookingsLinkedProps) => {
  const { data: giftCardBookings, isLoading: isLoadingBookings } =
    useGiftCardBookings(code);

  const history = useHistory();

  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const handleActionClick = ({ code, isLegacy }: GiftCardBooking) => {
    history.push(`/bookings/${isLegacy ? `legacy/${code}` : code}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const handleRowClick = ({ code, isLegacy }: GiftCardBooking) => {
    return {
      onClick: () =>
        history.push(`/bookings/${isLegacy ? `legacy/${code}` : code}`),
    };
  };

  return (
    <div className="bloc">
      <div className="title">Bookings linked</div>
      <Table
        dataSource={giftCardBookings}
        pagination={false}
        rowKey="code"
        onRow={handleRowClick}
        loading={isLoadingBookings}
      >
        <Column className="strong" key="code" title="Code" dataIndex="code" />
        <Column
          key="checkIn"
          title="Date"
          sorter={sortBookingsByDateField}
          defaultSortOrder="descend"
          dataIndex="checkIn"
          render={dateTimeCell('DD/MM/YYYY')}
        />
        <Column
          key="giftcardAmount"
          title="Amount"
          sorter={sortBookingsByAmountField}
          render={(amount) => <div>{formatCurrency(amount, currency)}</div>}
          dataIndex="giftcardAmount"
        />
        <Column
          key="actions"
          onCell={() => ({ onClick: (e) => e.stopPropagation() })}
          render={(entity) => (
            <ActionCellMenu
              entity={entity}
              handleActionClick={handleActionClick}
            />
          )}
        />
      </Table>
    </div>
  );
};
